module.exports = __webpack_public_path__ + "static/media/impact-save-trees.c61ea79b.svg";